import React from "react";
import { Link } from "react-router-dom";

const Card = ({ title, bestFor, gain, image, link }) => {
  return (
    <div className="flex flex-col md:flex-row items-center md:items-start gap-4 p-4 md:p-6 shadow-2xl rounded-lg max-w-5xl bg-white mx-auto border border-gray-300">
      {/* Image & Title Section */}
      <div className="w-full md:w-1/4 flex flex-col items-center text-center">
        <img
          src={image}
          alt={title}
          className="w-32 h-32 md:w-40 md:h-40 object-cover rounded-md mt-2"
        />
      </div>

      {/* Text Content */}
      <div className="flex-1 text-sm md:text-base mb:items-center mb:text-center">
      <h3 className="text-secondary text-lg md:text-left text-center md:text-xl font-bold mb-2 md:mb-3">{title}</h3>

        <p className="text-gray-600 text-left  font-semibold mb-2 md:mb-1">
          <span className="text-primary">Best for:</span> {bestFor}
        </p>
        <p className="text-gray-600 font-semibold mb-2 md:mb-4">
          <span className="text-primary text-left ">What will you gain:</span> {gain}
        </p>
        <Link
          to={link}
          className="text-blue-600 underline font-semibold text-center md:text-left block text-sm md:text-md"
        >
          View Details
        </Link>
      </div>
    </div>
  );
};

export default Card;
